import { ECmsCollection } from "./cms-collection.enum";
import { z } from "zod";

const CmsCollectionSchema = z.nativeEnum(ECmsCollection);
const CmsCollectionOrWildcardSchema = z.union([CmsCollectionSchema, z.literal("*")]);

export const CmsUserPermissionsDtoSchema = z.object({
  id: z.uuid(),
  email: z.email(),
  collections: z.array(CmsCollectionOrWildcardSchema),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type CmsUserPermissionsDto = z.infer<typeof CmsUserPermissionsDtoSchema>;

export const GetMyPermissionsResponseSchema = z.object({
  collections: z.array(CmsCollectionSchema),
  isSuperAdmin: z.boolean(),
});
export type GetMyPermissionsResponseDto = z.infer<typeof GetMyPermissionsResponseSchema>;

export const GetAllUsersPermissionsResponseSchema = z.array(CmsUserPermissionsDtoSchema);
export type GetAllUsersPermissionsResponseDto = z.infer<typeof GetAllUsersPermissionsResponseSchema>;

export const UpsertUserPermissionsDtoSchema = z.object({
  email: z.email(),
  collections: z.array(CmsCollectionOrWildcardSchema),
});
export type UpsertUserPermissionsDto = z.infer<typeof UpsertUserPermissionsDtoSchema>;

export const DeleteUserPermissionsQuerySchema = z.object({
  email: z.email(),
});
export type DeleteUserPermissionsQueryDto = z.infer<typeof DeleteUserPermissionsQuerySchema>;

export const CmsPermissionsSuccessResponseSchema = z.object({
  message: z.string(),
});
export type CmsPermissionsSuccessResponseDto = z.infer<typeof CmsPermissionsSuccessResponseSchema>;
